<template>
  <v-card>
    <v-card-title style="height: 48px; flex-wrap: nowrap;">
      <v-layout class="roomTileHeader" row>
        <v-flex>
          <span class="roomName" :style="roomNameStyle">{{room.name}}</span>
          <v-chip v-if="showOccupancyBadge" color="grey" text-color="white" cursor="pointer" disabled>{{ badgeText }}</v-chip>
        </v-flex>
      </v-layout>
      <v-spacer></v-spacer>
      <v-btn xs icon flat @click.stop="cancel()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>

    <v-divider></v-divider>

    <v-card-text style="height: calc(90vh - 104px); overflow-y: hidden;">
      <v-layout row>
        <span class="roomCardValue" :style="editStyle">
          <div class="ntstValueLabel">Room Type</div>
          <v-select v-if="isEditable" class="staySelector" v-model="roomTypeCodeValue" :items="roomTypeCodes" outline item-value="code" item-text="displayName"></v-select>
          <div v-if="!isEditable" style="margin-top: 6px;">{{ roomTypeCodeDisplayName }}</div>
        </span>
        <span class="roomCardValue" :style="editStyle">
          <div class="ntstValueLabel">Room Status</div>
          <v-select v-if="isEditable" class="staySelector" v-model="roomStatusCodeValue" :items="roomStatusCodes" outline item-value="code" item-text="displayName"></v-select>
          <div v-if="!isEditable" style="margin-top: 6px;">{{ roomStatusCodeDisplayName }}</div>
        </span>
        <span style="width:100%;">
          <div class="ntstValueLabel">Note</div>
          <v-text-field v-model="room.currentNote" outline></v-text-field>
        </span>
      </v-layout>

      <v-divider></v-divider>

      <v-layout row  style="overflow-x: auto;">
        <v-flex v-for="(stay, index) of actionableStays" :key="index">
          <stay-card :unit="unit" :room="room" :stay="stay" :isCloseVisible="false" :isEditable="false" :isShowingInRoomCard="true" :isStaffNotesEditable="false"></stay-card>
        </v-flex>
      </v-layout>

    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="ntstAppButton" @click.stop="cancel() ">
        Cancel
      </v-btn>

      <v-btn class="ntstAppButton" @click.stop="save() ">
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="js">
import StayCard from './StayCard.vue';

export default {
  name: 'RooomCard',
  data() {
    return {
    };
  },
  props: {
    isEditable: { default: false, type: Boolean },
    onCancel: Function,
    onSave: Function,
    room: Object,
    unit: Object
  },
  components: {
    'stay-card': StayCard,
  },
  computed: {
    actionableStays() {
      let actualStays = null;
      if (this.room && this.room.stays) {
        actualStays = this.room.stays.filter(stay => this.$store.getters.isStayActionable(stay));
      }
      return actualStays;
    },
    badgeText() {
      let returnValue = null;

      if (this.showOccupancyBadge) {
        returnValue = this.$store.getters.getRoomBadgeText(this.room);
      }

      return returnValue;
    },
    editStyle() {
      let returnValue = null;
      if (!this.isEditable) {
        returnValue = {
          minWidth: '100px'
        };
      }
      return returnValue;
    },
    roomNameStyle() {
      let returnValue = null;
      if (this.room && this.room.roomStatusCode) {
        const visualizedCodedEntry = this.$store.getters.getRoomStatusCode(this.room.roomStatusCode);
        if (visualizedCodedEntry) {
          returnValue = {
            color: visualizedCodedEntry.foregroundColorHexValue
              ? visualizedCodedEntry.foregroundColorHexValue
              : '#000000'
          };
        }
      }
      return returnValue;
    },
    roomStatusCodes() {
      return this.$store.getters.roomStatusCodes;
    },
    roomStatusCodeDisplayName: {
      get() {
        let returnValue = null;
        if (this.room && this.room.roomStatusCode) {
          if (this.room.roomStatusCode.displayName) {
            returnValue = this.room.roomStatusCode.displayName;
          } else {
            returnValue = this.room.roomStatusCode.code;
          }
        }
        return returnValue;
      }
    },
    roomStatusCodeValue: {
      get() {
        let returnValue = null;
        if (this.room && this.room.roomStatusCode) {
          returnValue = this.room.roomStatusCode.code;
        }
        return returnValue;
      },
      set(newValue) {
        if (this.room) {
          if (this.room.roomStatusCode) {
            this.room.roomStatusCode.code = newValue;
          } else {
            this.room.roomStatusCode = { code: newValue };
          }
        }
      }
    },
    roomTypeCodes() {
      return this.$store.getters.roomTypeCodes;
    },
    roomTypeCodeDisplayName: {
      get() {
        let returnValue = null;
        if (this.room && this.room.roomTypeCode) {
          if (this.room.roomTypeCode.displayName) {
            returnValue = this.room.roomTypeCode.displayName;
          } else {
            returnValue = this.room.roomTypeCode.code;
          }
        }
        return returnValue;
      }
    },
    roomTypeCodeValue: {
      get() {
        let returnValue = null;
        if (this.room && this.room.roomTypeCode) {
          returnValue = this.room.roomTypeCode.code;
        }
        return returnValue;
      },
      set(newValue) {
        if (this.room) {
          if (this.room.roomTypeCode) {
            this.room.roomTypeCode.code = newValue;
          } else {
            this.room.roomTypeCode = { code: newValue };
          }
        }
      }
    },
    showOccupancyBadge() {
      return this.room.isMaximumOccupancyEnforced || this.room.MaximumOccupancyCount > 0;
    }
  },
  methods: {
    cancel() {
      this.onCancel();
    },

    save() {
      this.onSave(this.room);
    }
  },
};
</script>

<style lang="scss">
.roomCardValue {
  margin-right: 15px;
}
table.scrolling td,
table.scrolling th {
  max-width: 100% !important;
}
</style>
